import React from 'react';
import { cn } from '@/lib/utils';

const Text = ({ children, className }) => {
  return (
    <p
      className={cn(
        'text-center font-rubik text-[16px] font-medium capitalize leading-[26px] tracking-normal text-[#7A8B87]',
        'md:text-left md:text-[20px]',
        className,
      )}
    >
      {children}
    </p>
  );
};

export default Text;
